let adController = null;

export function getAdController() {
  if (!adController) {
    adController = window.Adsgram.init({ blockId: 'int-46670' });
  }
  return adController;
}
